import { AppstoreOutlined, CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined, DownOutlined, ExclamationCircleOutlined, FileTextOutlined, MenuOutlined, StopOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu, Tag } from "antd";
import { SINISTER_COLORS } from "../../../../components/ui/colors";

export const TAB_CONFIG = {
    "1": { url: `/api/sinistre/instance` },
    "2": { url: `/api/sinistre/ouverts` },
    "3": { url: `/api/sinistre/refuses` },
    "4": { url: `/api/sinistre/closed` },
    "5": { url: `/api/sinistre/sans-suite` },
    "6": { url: `/api/sinistre/a-valider` },
    "7": { url: `/api/sinistre/sql` },
    // Sinistres dont le CONTRAT porte au moins une garantie créée par une compagnie
    // (ne relève pas du Pool) — pendant de l'onglet « Garanties hors Pool » de /production.
    "8": { url: `/api/sinistre/hors-pool` },
};

export const stats = (count) => [
    {
        title: 'Total Sinistres',
        value: count.totalSinistres,
        subtitle: 'Tous les dossiers',
        icon: "bx bx-list-ul",
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: '#667eea'
    },
    {
        title: 'En Cours',
        value: count.totalSinistresVivants,
        subtitle: 'Dossiers actifs',
        icon: "bx bx-loader",
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: '#667eea'
    },
    {
        title: 'Terminés',
        value: count.totalSinistresSoldes,
        subtitle: 'Dossiers soldés',
        icon: "bx bx-check-circle",
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: '#667eea'
    },
    {
        title: 'Sans Suite',
        value: count.totalSinistresSansSuite,
        subtitle: 'Dossiers clôturés',
        icon: "bx bx-x-circle",
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: '#667eea'
    },
    {
        title: 'À Valider',
        value: count.totalSinistresNonValides,
        subtitle: 'En attente',
        icon: "bx bx-time",
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: '#667eea'
    }
];

const actionMenu = (record, navigate) => (
    <Menu
        items={[
            {
                key: "1",
                label: (
                    <Button
                        onClick={() => {
                            navigate(`/details-sinistre/v2`, { state: { codeId: record.key } });
                        }}
                    >
                        Détails
                    </Button>
                ),
                icon: <MenuOutlined />,
            },
        ].filter(Boolean)}
    />
);

const ActionCell = ({ record, navigate }) => (
    <Dropdown overlay={actionMenu(record, navigate)}>
        <Button icon={<DownOutlined />} />
    </Dropdown>
);

export const allColumns = (navigate) => [
    {
        title: "N° Sinistre",
        dataIndex: "numeroSinistre",
        key: "numeroSinistre",
        ellipsis: true,
    },
    { title: "N° Police", dataIndex: "numeroPolice", key: "numeroPolice", ellipsis: true },
    { title: "Assuré", dataIndex: "assure", key: "assure", ellipsis: true },
    { title: "Survenance", dataIndex: "dateSinistre", key: "dateSinistre", width: 110 },
    {
        title: "Déclaration",
        dataIndex: "dateDeclaration",
        key: "dateDeclaration",
        width: 110,
    },
    {
        title: "Durée",
        dataIndex: "duree",
        key: "duree",
        width: 90,
        render: (duree, record) => <Tag color={record?.daysDuree > 5 ? "red" : "purple"}>{duree}</Tag>,
    },
    {
        title: "Etat",
        dataIndex: "etat",
        key: "etat",
        width: 128,
        render: (statut) => {
            const config = getStatusConfig(statut);
            return (
                <Tag
                    icon={config.icon}
                    color={config.color}
                    style={{
                        borderRadius: '6px',
                        padding: '4px 12px',
                        fontWeight: 500,
                        background: config.bg,
                        border: `1px solid ${config.color}`,
                        color: "black"
                    }}
                >
                    {config.text}
                </Tag>
            );
        },
        filters: [
            { text: "À VALIDER", value: "A" },
            { text: "EN ATTENTE", value: "EN_ATTENTE" },
            { text: "EN INSTANCE", value: "EN_INSTANCE" },
            { text: "OUVERT", value: "O" },
            { text: "REFUSÉ", value: "RF" },
            { text: "TERMINÉ", value: "TERMINE" },
            { text: "SANS SUITE", value: "SANS_SUITE" },
        ],
    },
    { title: "Évaluation", dataIndex: "evaluation", key: "evaluation", align: "right", width: 120 },
    {
        title: "", // en-tête vide : colonne d'actions compacte, collée au bord droit
        dataIndex: "actions",
        key: "actions",
        align: "center",
        width: 56,
        render: (_, record) => <ActionCell record={record} navigate={navigate} />,
    },
];

export const columns = (navigate) => [
    {
        title: "N° Sinistre",
        dataIndex: "numeroSinistre",
        key: "numeroSinistre",
        ellipsis: true,
    },
    { title: "N° Police", dataIndex: "numeroPolice", key: "numeroPolice", ellipsis: true },
    { title: "Assuré", dataIndex: "assure", key: "assure", ellipsis: true },
    { title: "Survenance", dataIndex: "dateSinistre", key: "dateSinistre", width: 110 },
    {
        title: "Déclaration",
        dataIndex: "dateDeclaration",
        key: "dateDeclaration",
        width: 110,
    },
    {
        title: "Durée",
        dataIndex: "duree",
        key: "duree",
        width: 90,
        render: (duree, record) => <Tag color={record?.daysDuree > 5 ? "red" : "purple"}>{duree}</Tag>,
    },
    { title: "Évaluation", dataIndex: "evaluation", key: "evaluation", align: "right", width: 120 },
    {
        title: "", // en-tête vide : colonne d'actions compacte, collée au bord droit
        dataIndex: "actions",
        key: "actions",
        align: "center",
        width: 56,
        render: (_, record) => <ActionCell record={record} navigate={navigate} />,
    },
];

export const tabsDefinition = (data, count) => [
    {
        key: "1",
        label: "Dossiers en cours",
        icon: <ClockCircleOutlined className="tab-icon" />,
        count: count?.totalSinistresVivants || 0,
    },
    {
        key: "2",
        label: "Sinistres ouverts / validés",
        icon: <CheckCircleOutlined className="tab-icon" />,
        count: data.filter((r) => ["O", "OUVERT"].includes(r.etatCodeSanitized)).length,
    },
    {
        key: "3",
        label: "Sinistres refusés",
        icon: <CloseCircleOutlined className="tab-icon" />,
        count: data.filter((r) => ["RF", "REFUSE"].includes(r.etatCodeSanitized)).length,
    },
    {
        key: "4",
        label: "Dossiers soldés",
        icon: <FileTextOutlined className="tab-icon" />,
        count: count?.totalSinistresSoldes || 0,
    },
    {
        key: "5",
        label: "Dossiers sans suite",
        icon: <StopOutlined className="tab-icon" />,
        count: count?.totalSinistresSansSuite || 0,
    },
    {
        key: "6",
        label: "À valider",
        icon: <ExclamationCircleOutlined className="tab-icon" />,
        count: count?.totalSinistresNonValides || 0,
    },
    {
        key: "7",
        label: "Tous les sinistres",
        icon: <AppstoreOutlined className="tab-icon" />,
        count: count?.totalSinistres || 0,
    },
];



const getStatusConfig = (etat, aValider = false) => {
    // À VALIDER - priorité si aValider est true ou etat === 0
    if (aValider || etat === 0) {
        return {
            color: '#F39C12', // Or/Gold
            bg: '#FEF5E7',
            icon: <ExclamationCircleOutlined />,
            text: 'À VALIDER'
        };
    }

    const configs = {
        1: { // EN INSTANCE
            color: SINISTER_COLORS.primary, // Vert émeraude
            bg: SINISTER_COLORS.primaryLight,
            icon: <ClockCircleOutlined />,
            text: 'EN INSTANCE'
        },
        2: { // OUVERT
            color: '#F1C40F', // Jaune
            bg: '#FEF9E7',
            icon: <FileTextOutlined />,
            text: 'OUVERT'
        },
        3: { // TERMINÉ
            color: SINISTER_COLORS.primaryDark, // Vert sapin
            bg: SINISTER_COLORS.primaryLight,
            icon: <CheckCircleOutlined />,
            text: 'TERMINÉ'
        },
        4: { // SANS SUITE
            color: SINISTER_COLORS.info, // Bleu
            bg: '#EBF5FB',
            icon: <CloseCircleOutlined />,
            text: 'SANS SUITE'
        },
        5: { // RÉOUVERT
            color: SINISTER_COLORS.grayDark, // Gris foncé
            bg: '#F5F5F5',
            icon: <ClockCircleOutlined />,
            text: 'RÉOUVERT'
        },
        8: { // REFUSÉ
            color: SINISTER_COLORS.danger, // Rouge
            bg: '#FADBD8',
            icon: <CloseCircleOutlined />,
            text: 'REFUSÉ'
        }
    };

    return configs[etat] || {
        color: SINISTER_COLORS.grayDark,
        bg: '#F5F5F5',
        icon: <FileTextOutlined />,
        text: etat?.toString() || '-'
    };
};